<div [formGroup]="formUpload" class="page-section card">
  <div class="card-body d-flex flex-column gap-3">
    <div class="row">
      <div class="col-12 col-sm-4">
        <div class="mb-3 mb-sm-0 flex flex-column gap-2">
          <p-select
            formControlName="provider"
            [options]="providers"
            optionLabel="provider"
            optionValue="id"
            [checkmark]="true"
            [filter]="true"
            filterBy="provider"
            [showClear]="true"
            placeholder="Proveedor"
            class="w-100 h-50px"
          >
          </p-select>
          <small class="ps-2">Proveedor <span class="text-danger">Requerido *</span></small>
        </div>
      </div>
      <div class="col-12 col-sm-4">
        <p-button label="Procesar" class="d-block h-50px" styleClass="h-100" [loading]="isUploading" (onClick)="upload()" [disabled]="this.formUpload.invalid || this.files.controls.length === 0" />
      </div>
    </div>

    <form id="upload">
      <p class="m-auto position-absolute start-0 end-0 bottom-0 top-0 d-flex flex-column justify-content-center align-items-center fs-4 fw-normal opacity-50">Da click o arrastra los archivos</p>
      <input (change)="onInputFileChanged($event)" type="file" class="form-control" accept=".pdf" multiple />
    </form>

    <div class="d-flex flex-wrap gap-3">
      @for (item of files.controls; track item; let index = $index) {
      <div formArrayName="files">
        <div class="card h-100 border-0" [ngClass]="{ 'text-bg-light': getFilesAsIndex(index)?.errors === null, 'text-bg-danger text-white': getFilesAsIndex(index)?.errors !== null }">
          <div class="card-body d-flex align-items-center gap-3">
            <p class="m-0">
              {{ item.value.file.name }}
              @if (getFilesAsIndex(index)?.hasError('requiredFileSize')) {
              <small class="d-block">El tamaño del archivo no debe ser mayor a 2mb.</small>
              } @if (getFilesAsIndex(index)?.hasError('requiredFileType')) {
              <small class="d-block">No es un archivo válido.</small>
              }
            </p>

            <p-button icon="pi pi-trash" severity="danger" (click)="removeFile(index)"></p-button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div class="page-section card">
  <div class="card-body p-0">
    <p-table #dt1 [value]="this.list" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [globalFilterFields]="['curp']">
      <ng-template pTemplate="caption">
        <div class="d-flex align-items-stretch justify-content-between gap-2">
          <p-inputgroup>
            <p-iconfield class="w-100">
              <p-inputicon styleClass="pi pi-search" />
              <input type="text" pInputText [(ngModel)]="searchValue" (input)="dt1.filterGlobal(searchValue, 'contains')" placeholder="Buscar por CURP." class="w-100 h-50px rounded-end-0" />
            </p-iconfield>
            <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
              <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>CURP</th>
          <th>FECHA</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="text-nowrap">{{ item.curp }}</td>
          <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6">No se encontraron registros.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
